// extracted by mini-css-extract-plugin
export default {"appBody":"Overview_appBody__EzDva","content":"Overview_content__4agSo","title":"Overview_title__FnZTk","spacer":"Overview_spacer__QClhE","vspacer":"Overview_vspacer__ExOWr"};